// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"zo1eh8K","body":"V5dGGIi","body-margin":"hd8TNzj","bodyMargin":"hd8TNzj","small-image":"F7HqibD","smallImage":"F7HqibD","footer":"w6yqs8w"};